module.exports = __webpack_public_path__ + "media/images/flags/bh-0bcef270ef4fe8b473b718e28925f3c7.svg";